<template>
  <v-dialog
    v-model="visible"
    persistent
    width="350"
  >
    <v-card>
      <v-card-text>
        <v-form>
          <v-textarea
            v-model="value"
            no-resize
            rows="1"
            label="Значение"
            placeholder="Строка"
          />

          <v-btn
            small
            color="primary"
            @click="update"
          >
            Применить
          </v-btn>
          <v-btn
            small
            @click="closeDialog"
          >
            Отмена
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
  },
  props: [
    "visible",
  ],
  data() {
    return {
      value: "",
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    update() {
      this.$emit("onUpdate", this.value);
      this.closeDialog();
    },
    closeDialog() {
      this.value = "";
      this.$emit("onClose");
    },
  },
};
</script>

<style>

</style>
